import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import Box from '@mui/material/Box';
import Divider, { dividerClasses } from '@mui/material/Divider';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/icons-material/FormatAlignLeft": FormatAlignLeftIcon, "@mui/icons-material/FormatAlignCenter": FormatAlignCenterIcon, "@mui/icons-material/FormatAlignRight": FormatAlignRightIcon, "@mui/icons-material/FormatBold": FormatBoldIcon, "@mui/material/Box": Box, "@mui/material/Divider": Divider } } });
export default ClientProvider;
